"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPageMarkedForCacheCleanup = void 0;
var _logger = require("../logger");
const pagePathPatterns = ['/shopping/basket'];
const isPageMarkedForCacheCleanup = () => {
  const isCleanupPage = pagePathPatterns.some(item => window.location.pathname.includes(item));
  if (isCleanupPage) {
    (0, _logger.logDebug)('Cache cleanup is always requested for current page.');
  }
  return isCleanupPage;
};
exports.isPageMarkedForCacheCleanup = isPageMarkedForCacheCleanup;
//# sourceMappingURL=clearCachePages.js.map